<template>
  <div
    class="flex items-center justify-center gap-1"
    :class="{ '@container/progress': hasFixedWidth }"
  >
    <div
      class="flex-column m-0 flex h-4 w-full min-w-[90px] flex-shrink-0 cursor-pointer overflow-hidden rounded-md bg-gray-100 p-0 shadow"
      :class="{ 'hidden @7xs/progress:flex': isCollapsible && hasFixedWidth }"
      @click="onClick"
    >
      <div data-tint="danger" class="bg-primary leading-none" :style="style0" />
      <div
        data-tint="warning"
        class="bg-primary leading-none"
        :style="style1"
      />
      <div
        data-tint="success"
        class="bg-primary leading-none"
        :style="style2"
      />
      <div
        data-tint="primary"
        class="bg-primary leading-none"
        :style="style9"
      />
    </div>
    <button
      v-if="navigationRouteName"
      type="button"
      class="text-slate-400 hover:text-slate-600"
      @click.stop="navigate"
    >
      <FontAwesomeIcon
        :icon="['fal', 'arrow-up-right-from-square']"
        size="xs"
      />
    </button>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { isFixedWidthColumn } from '@c/Dashboard/Content/Dossier/components/Body/columnWidth'
import { normalizeFieldIds, getProgressDataForIds } from './progressBarData'

const NAVIGATION_ROUTE_BY_GROUP = {
  FUN: 'dossier_form_coffin_and_product_route_display',
  FLO: 'dossier_form_flowers_route',
  PRI: 'dossier_form_prints_route',
  OTH: 'dossier_form_other_products_route',
  EXT: 'dossier_form_external_services_route'
}

export default {
  name: 'TaskProgressBar',
  components: { FontAwesomeIcon },
  props: {
    column: { type: Object, required: true },
    dossier: { type: Object, required: true }
  },
  emits: ['toggle-tasks'],
  computed: {
    fieldIds() {
      return normalizeFieldIds(this.column.field)
    },
    progressData() {
      return getProgressDataForIds(this.dossier.tasks_progress, this.fieldIds)
    },
    navigationRouteName() {
      if (this.fieldIds.length !== 1) return null
      return NAVIGATION_ROUTE_BY_GROUP[this.fieldIds[0]] ?? null
    },
    hasFixedWidth() {
      return isFixedWidthColumn(this.column)
    },
    // The bar may only collapse when the shortcut button survives it, so a
    // narrow column never ends up showing an empty cell.
    isCollapsible() {
      return this.navigationRouteName !== null
    },
    style0() {
      return { width: (this.progressData.tasks_0_percentage ?? 0) + '%' }
    },
    style1() {
      return { width: (this.progressData.tasks_1_percentage ?? 0) + '%' }
    },
    style2() {
      return { width: (this.progressData.tasks_2_percentage ?? 0) + '%' }
    },
    style9() {
      return { width: (this.progressData.tasks_9_percentage ?? 0) + '%' }
    }
  },
  methods: {
    onClick() {
      if (this.fieldIds.includes('ALL')) {
        this.$emit('toggle-tasks', { columnId: null })
        return
      }

      this.$emit('toggle-tasks', {
        columnId: this.column.id,
        field: this.column.field
      })
    },
    navigate() {
      this.$router.push({
        name: this.navigationRouteName,
        params: { id: this.dossier.id }
      })
    }
  }
}
</script>
